<template>
    <div>
        <p v-if="!disableTextTypeChoosing" class="accordion-body-heading mx-2">
            <span>
                {{ hebrew ? 'בחר את סגנון הטקסט אותו תרצה לפענח' : 'Choose text style' }}:
            </span>
        </p>
        <ul class="chapter2 list-unstyled accordion-list">
            <li v-for="(textType, textTypeIndex) in textTypesToShow"
                :key="textTypeIndex"
                @click="chosenTextTypeIndex = disableTextTypeChoosing ? chosenTextTypeIndex : textTypeIndex">
                <b-form-radio v-bind:id="'use-' + textType.name + '-nakdan'"
                                v-bind:value="textTypeIndex"
                                :disabled="disableTextTypeChoosing"
                                v-model="chosenTextTypeIndex">{{ hebrew ? textType.displayText : textType.engDisplayText}}
                </b-form-radio>
            </li>
        </ul>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {AppConfig} from '../appConfig'
    import {loadingPromise} from '@/js/localData'

    const textTypes = [
                    {
                        name: 'modern',
                        displayText: 'טקסט מודרני',
                        engDisplayText: 'Modern text'
                    },
                    {
                        name: 'rabbinic',
                        displayText: 'טקסט רבני',
                        engDisplayText: 'Rabbinic text'
                    },
                    {
                        name: 'poetry',
                        displayText: 'טקסט שירה',
                        engDisplayText: 'Poetic Text'
                    }
                ]
    if (AppConfig.TALMUD_GENRE.INCLUDE) textTypes.push({
        name: 'talmud',
        displayText: 'טקסט מהתלמוד',
        engDisplayText: 'Talmud text'
    })

    export default {
        name: 'DocumentSettingsGenre',
        data() {
            return { // note these are all "initial" values, to be finalized in mounted()
                chosenTextTypeIndex: 0,
                chosenTextTypeName: textTypes[0].name,
                textTypesToShow: [...textTypes], // make a copy each render (so additions won't stick)
                disableTextTypeChoosing: false
            }
        },
        props: ['options'],
        computed: {
            hebrew () {
                return this.$settings.hebrew
            }
        },
        watch: {
            chosenTextTypeIndex(newChosenTextTypeIndex) {
                this.options.chosenTextTypeName = this.textTypesToShow[newChosenTextTypeIndex].name
            }
        },
        async mounted () { // NOT "created" - to give shared/dropbox/SaveToDropbox.disconnectDropboxData() time
            await loadingPromise
            this.chosenTextTypeName = this.options.chosenTextTypeName
            const abbrevProjectSettings = this.$store.state.dropbox?.projectSettings?.abbreviation
            this.disableTextTypeChoosing = abbrevProjectSettings
            if (this.disableTextTypeChoosing) {
                const genreMode = abbrevProjectSettings.genreMode // below will work even if it's undefined
                if (!(textTypes.map(t => t.name).includes(genreMode))) {
                    this.textTypesToShow.push({ name: 'other', displayText: 'אחר', engDisplayText: 'Other' })
                    this.chosenTextTypeName = 'other'
                } else this.chosenTextTypeName = genreMode
            }
            this.chosenTextTypeIndex = Math.max(0,
                                        this.textTypesToShow.map(t => t.name).indexOf(this.chosenTextTypeName))
        }
    }
</script>

<style scoped>
    /* DocumentSettingsGenre-specific CSS goes here */
    .text-type {
        display: flex;
        margin: 10px;
    }
    .accordion-body-heading {
        margin: 0 0 5px;
    }
    .accordion-list {
        margin: 0 10px;
        padding: 0;
    }
</style>
